import { LicenseLiabilityService } from './license-liability.service';
import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { empty } from 'rxjs';

@Injectable()
export class LicenseLiabilityResolverService implements Resolve<any> {
  constructor() { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   
    if (route.data['list']) {
    
      // return  this.service.getLicenseAndLiabilities().pipe(
        
      //   catchError((error) => {
        
      //     return empty();
      //   })
      // );
    }
    
  }
}